import { useState } from 'react'

// hook function
export default function useLocalStorage(key, initialValue) {

	const [storedValue, setStoredValue] = useState(() => {
		try {
			const item = window.localStorage.getItem(key)
			return item ? JSON.parse(item) : initialValue
		} catch (error) {
			console.log(error) // TODO: handle error
			return initialValue
		}
	})

	const setValue = value => {
		try {
			const valueToStore = value instanceof Function ? value(storedValue) : value
			setStoredValue(valueToStore)
			window.localStorage.setItem(key, JSON.stringify(valueToStore))
		} catch (error) {
			console.log(error) // TODO: handle error
		}
	}

	return [storedValue, setValue]
}
